import { useAiChatBotStore } from '../../core/store/useAiChatBotStore'

export function usePanelAnimation() {
  const { isOpen, isAnimatingOut } = useAiChatBotStore(
    ({ isOpen, isAnimatingOut }) => ({ isOpen, isAnimatingOut }),
  )
  const { animationDidEnd } = useAiChatBotStore.getState()
  const show = isOpen || isAnimatingOut
  const isClosing = isAnimatingOut

  const onAnimationEnd = () => {
    if (isAnimatingOut) animationDidEnd()
  }

  return { show, isClosing, onAnimationEnd }
}
